<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'AXS') : null) || false;
$: nextPage = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.nextPage) || undefined;
$: nextPageExistingAccount = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.nextPageExistingAccount) || undefined;
$: endWorkflowExistingAccount = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.endWorkflowExistingAccount) || undefined;
$: endWorkflow = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.endWorkflow;
onMount(() => {
    function afterConnect(existingAccount) {
        if (existingAccount && nextPageExistingAccount) {
            resolveUrl(nextPageExistingAccount).func();
        }
        else if (endWorkflow || (existingAccount && endWorkflowExistingAccount)) {
            signonManager.fireWorkflowEndEvent();
        }
        else if (nextPage) {
            resolveUrl(nextPage).func();
        }
        else if (signonManager.skipCompleteProfilePage) {
            resolveUrl(`ConnectAccounts`).func();
        }
        else {
            resolveUrl(`CompleteProfile`).func();
        }
    }
    if (connected) {
        afterConnect(true);
    }
    ycSSOThirdPartyAuth("AXS", clientConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        console.log("ycSSOThirdPartyAuth callback inside AXS", method, clientResult);
        if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.accessToken)) {
            console.warn(`ycSSOThirdPartyAuth callback for ${method}: no access token in client result`);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const result = yield signonManager.loginWithAxsAccount(clientResult.accessToken, true);
        if (result.success) {
            const existingAccount = result.data.AccountCreated === 'true';
            ycSSOSetState(existingAccount, result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            afterConnect(existingAccount);
        }
        else {
            alert(((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UserMessage) === null || _b === void 0 ? void 0 : _b.Content) || 'An error occurred.');
            signonManager.fireWorkflowEndEvent();
        }
    }));
});
</script>

<CardBase {element}>
</CardBase>
